import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import ScopedAccessGuard from "./ScopedAccessGuard";

const SOULUMO_PATHS = ["/soulumo", "/together/new", "/my-installations", "/my-journeys", "/my-library", "/signature-installations", "/voice-clone", "/voice-library"];

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center">
        <div className="animate-pulse-gentle text-[#4A6741]">Loading...</div>
      </div>
    );
  }

  if (!user) {
    // Preserve the intended path so login can redirect back after auth.
    const next = location.pathname + location.search;
    // Soulumo pages sign in through Soulumo, never the Reclaim login.
    if (SOULUMO_PATHS.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`))) {
      return <Navigate to={`/soulumo/join?mode=signin&next=${encodeURIComponent(next)}`} replace />;
    }
    const to = next && next !== "/" ? `/login?redirect=${encodeURIComponent(next)}` : "/login";
    return <Navigate to={to} replace />;
  }

  return <ScopedAccessGuard>{children}</ScopedAccessGuard>;
};
